<template>
  <CartBase
    :items="items"
    :order-config="orderConfig"
    container-classes="h-full flex flex-col bg-white shadow-xl"
    :show-pin-button="true"
    pin-button-type="unpin"
    :is-checkout-active="isCheckoutActive"
    :is-store-closed="isStoreClosed"
    :on-unpin="onUnpin"
    :on-update-quantity="onUpdateQuantity"
    :on-remove-item="onRemoveItem"
    :on-edit-item="onEditItem"
    :on-checkout="onCheckout"
  >
  </CartBase>
</template>

<script>
import CartBase from "./CartBase.vue";

export default {
  name: "CartSidebar",
  components: {
    CartBase
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    orderConfig: {
      type: Object,
      required: true
    },
    isPinned: {
      type: Boolean,
      default: true
    },
    isCheckoutActive: {
      type: Boolean,
      default: false
    },
    isStoreClosed: {
      type: Boolean,
      default: false
    },
    onUpdateQuantity: {
      type: Function,
      required: true
    },
    onRemoveItem: {
      type: Function,
      required: true
    },
    onEditItem: {
      type: Function,
      default: null
    },
    onCheckout: {
      type: Function,
      required: true
    },
    onUnpin: {
      type: Function,
      required: true
    }
  }
};
</script>
